<template>
  <div class="min-h-screen bg-gray-50 flex flex-col">
    <!-- Header Section -->
    <header class="bg-indigo-700 text-white py-16 px-6 text-center relative overflow-hidden">
      <div class="absolute inset-0 bg-grid-white/10 opacity-20"></div>
      <div class="relative z-10 max-w-4xl mx-auto">
        <h1 class="text-4xl md:text-5xl font-bold mb-4">{{ $t('privacy.title') }}</h1>
      </div>
    </header>

    <!-- Loading State -->
    <div v-if="loading" class="max-w-4xl mx-auto px-6 py-12 w-full">
      <div class="space-y-6">
        <div v-for="i in 5" :key="i" class="animate-pulse">
          <div class="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-full"></div>
            <div class="h-4 bg-gray-200 rounded w-5/6"></div>
            <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="max-w-4xl mx-auto px-6 py-12 text-center">
      <p class="text-base text-gray-700">{{ error }}</p>
    </div>

    <!-- Content Section -->
    <main v-else class="max-w-4xl mx-auto px-6 pb-16 text-gray-700 pt-8">
      <div class="bg-white rounded-lg shadow-sm p-6 md:p-8 mb-8">
        <p class="text-gray-600 mb-6">
          {{ $t('privacy.intro') }}
        </p>

        <section
          v-for="(policy) in policies"
          :key="policy.id"
          class="mb-8 last:mb-0"
          :id="`section-${policy.id}`"
        >
         <div v-html="formatTextToHtml(policy.content)"></div>
          
        </section>
      </div>

      <div class="bg-white rounded-lg shadow-sm p-6 md:p-8">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">{{ $t('privacy.acceptanceTitle') }}</h2>
        <p class="text-gray-600">{{ $t('privacy.acceptanceText') }}</p>
      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-white border-t border-gray-200 py-6 mt-auto">
      <div class="max-w-4xl mx-auto px-6 text-center text-gray-500 text-sm">
        <p>{{ $t('privacy.contactNote') }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'PrivacyPolicyPage',
  data() {
    return {
      policies: [],
      loading: true,
      error: null,
      lastUpdated: null
    }
  },
  async created() {
    await this.fetchPolicies()
  },
  methods: {
      formatTextToHtml(text) {
    return text
      .replace(/\n/g, '<br>') 
      .replace(/(\d+)\.\s/g, '<br><strong>$1.</strong> '); 
  },
    async fetchPolicies() {
      this.loading = true
      this.error = null

      try {
        const response = await api.get('v1/privacy', {
          params: { lang_code: this.$i18n.locale }
        })
        this.policies = response.data || []
        this.lastUpdated = new Date().toLocaleDateString()

        if (this.policies.length === 0) {
          this.error = this.$t('privacy.empty')
        }
      } catch (err) {
        console.error('Failed to load privacy policies:', err)
        this.error = err.response?.data?.message || this.$t('privacy.loadError')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
:deep(.prose a) {
  color: #3b82f6;
  text-decoration: none;
  font-weight: 500;
}

:deep(.prose a:hover) {
  text-decoration: underline;
}

:deep(.prose ul),
:deep(.prose ol) {
  padding-left: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:deep(.prose ul) {
  list-style-type: disc;
}

:deep(.prose ol) {
  list-style-type: decimal;
}

:deep(.prose li) {
  margin-bottom: 0.25rem;
}
</style>

